import React from "react";

const HtmlToTags = (props) => {
  const { className = "", selectedData ,source_field } = props;

  const IndirectEval = (evalString) => {
    try {
        return eval(evalString);
    } catch (error) {
        return "";
    }
  };

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: [IndirectEval(source_field)] }}
    />
  );
};

export default HtmlToTags;
